'use strict';
const mmWidgets = require('../widgets/mm-widgets');

mmWidgets.fn.addToRowAtIndex = function (container, index) {
	const element = this,
		role = element.attr('data-mm-role'),
		current = container.children(`[data-mm-role~="${role}"]`).eq(index);
	if (current.length) {
		element.insertBefore(current);
	} else {
		element.appendTo(container);
	}
	return element;
};
